import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FormStateService, PlatformPackageId } from '../../services/form-state.service';

interface PackageOption {
  id: PlatformPackageId;
  name: string;
  price: string;
  included: string;
  description: string;
  recommended?: boolean;
}

@Component({
  selector: 'app-package-select-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatRadioModule],
  templateUrl: './package-select-form.component.html',
  styleUrl: './package-select-form.component.scss'
})
export class PackageSelectFormComponent implements OnInit {
  packageForm!: FormGroup;

  readonly packages: PackageOption[] = [
    {
      id: 'society',
      name: 'Society',
      price: '$299/mo',
      included: '500 active members included',
      description: 'The complete MemberTrace platform for most independent organizations.',
      recommended: true,
    },
    {
      id: 'growth',
      name: 'Growth',
      price: '$599/mo',
      included: '1,500 active members included',
      description: 'Advanced permissions, integrations, custom workflows, and reporting.',
    },
  ];

  constructor(private readonly formStateService: FormStateService) {}

  ngOnInit(): void {
    this.packageForm = this.formStateService.getForm().get('packageInformation') as FormGroup;
  }

  selectPackage(id: PlatformPackageId): void {
    this.packageForm.get('platformPackage')?.setValue(id);
  }

  isSelected(id: PlatformPackageId): boolean {
    return this.packageForm.get('platformPackage')?.value === id;
  }
}
